import { render, staticRenderFns } from "./IconFireSolid.vue?vue&type=template&id=88dff642"
import script from "./IconFireSolid.vue?vue&type=script&lang=js"
export * from "./IconFireSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports